import type { JSONValue } from '../contexts';

type RemoteConfigNumberTuple = [string, number];
type RemoteConfigStringTuple = [string, string];

type TJsonObject = { [key: string]: JSONValue };
type RemoteConfigJSONTuple<T = unknown> = [string, T];

export const FREE_SHIPPING_THRESHOLD: RemoteConfigNumberTuple = [
  'delivery_free_shipping_threshold',
  69,
];

export const MINIMUM_ORDER_AMOUNT: RemoteConfigNumberTuple = [
  'minimum_order_amount',
  0,
];

export const DEFAULT_ANNUAL_SUBSCRIPTION_PRICE = 59.9;

export const ANNUAL_SUBSCRIPTION_PRICE: RemoteConfigNumberTuple = [
  'subscription_price',
  DEFAULT_ANNUAL_SUBSCRIPTION_PRICE,
];

export const DEFAULT_MONTHLY_SUBSCRIPTION_PRICE = 9.9;

export const MONTHLY_SUBSCRIPTION_PRICE: RemoteConfigNumberTuple = [
  'monthly_subscription_price',
  DEFAULT_MONTHLY_SUBSCRIPTION_PRICE,
];

export const PAYPAL_4X_MIN_ELIGIBILITY: RemoteConfigNumberTuple = [
  'paypal_4x_min_eligibility',
  30,
];

export const PAYPAL_4X_MAX_ELIGIBILITY: RemoteConfigNumberTuple = [
  'paypal_4x_max_eligibility',
  2000,
];

export const REDIRECTION_TO_SUGGESTIONS_PAGE_RULE: RemoteConfigStringTuple = [
  'redirection_to_suggestions_page_rule',
  'mobile AND (orders < 1)',
];

export const OOS_RECOMMENDATIONS_WIDGET_ID: RemoteConfigStringTuple = [
  'oos_recommendations_widget_id',
  '',
];

interface IInAppReviewConfig extends TJsonObject {
  enabledOperatingSystems: string[];
  promptDelay: number;
}

export const IN_APP_REVIEW_PROMPT_CONFIG: RemoteConfigJSONTuple<IInAppReviewConfig> =
  [
    'in_app_review_config',
    {
      enabledOperatingSystems: [],
      promptDelay: 0,
    },
  ];

export const REFRESHED_DELIVERY = 'refreshedDelivery';
export const ZERO_WASTE_DELIVERY = 'zeroWasteDelivery';
export const DEFAULT_DELIVERY = 'defaultDelivery';

export const DELIVERY_FEES: RemoteConfigJSONTuple<{
  [key: string]: Array<{
    price: number;
    aboveAmount?: number;
    underAmount?: number;
  }>;
}> = [
  'detailed_delivery_fees',
  {
    [REFRESHED_DELIVERY]: [
      { price: 0, aboveAmount: 12900 },
      { price: 190, aboveAmount: 6900, underAmount: 12900 },
      { price: 390, aboveAmount: 3900, underAmount: 6900 },
      { price: 790, underAmount: 3900 },
    ],
    [ZERO_WASTE_DELIVERY]: [
      { price: 0, aboveAmount: 6900 },
      { price: 390, aboveAmount: 3900, underAmount: 6900 },
      { price: 790, underAmount: 3900 },
    ],
    [DEFAULT_DELIVERY]: [
      { price: 0, aboveAmount: 6900 },
      { price: 790, underAmount: 6900 },
    ],
  },
];

export const PROMOTION_COUPON_TOAST_MESSAGE = 'promotion_coupon_toast_message';

export const MINIMUM_BUILD_VERSION = 'minimum_build_version';

export const TEMPORARY_ADDRESS_REMOTENESS_LEVEL: RemoteConfigStringTuple = [
  'temporary_address_remoteness_level',
  'standard',
];

interface AverageProductBasketConfig extends TJsonObject {
  [key: `${number}`]: string;
}

export const CONFIG_AVERAGE_PRODUCT_BASKET: RemoteConfigJSONTuple<AverageProductBasketConfig> =
  [
    'config_average_product_basket',
    {
      '1': 'household-1',
      '2': 'household-2',
      '3': 'household-3',
      '4': 'household-4',
      '5': 'household-5',
    },
  ];

export const PUSH_NOTIFS_CONSENT_MAX_REQUESTS: RemoteConfigNumberTuple = [
  'config_app_push_notifs_consent_max_requests',
  6,
];

export const PUSH_NOTIFS_CONSENT_REQUEST_DELAY_IN_DAYS: RemoteConfigNumberTuple =
  ['config_app_push_notifs_consent_request_delay_in_days', 45];

type GetMerchandizingRecommendationProductsQueryParams = {
  limit: number;
};

export const GET_MERCHANDIZING_RECOMMENDATION_PRODUCTS_PAGE_QUERY_PARAMS: RemoteConfigJSONTuple<GetMerchandizingRecommendationProductsQueryParams> =
  [
    'get_merchandizing_recommendations_products_page_query_params',
    {
      limit: 30,
    },
  ];

export const GET_MERCHANDIZING_RECOMMENDATION_PRODUCTS_CAROUSEL_QUERY_PARAMS: RemoteConfigJSONTuple<GetMerchandizingRecommendationProductsQueryParams> =
  [
    'get_merchandizing_recommendations_products_carousel_query_params',
    {
      limit: 15,
    },
  ];

export const TOAST_FREE_DELIVERY_THRESHOLDS: RemoteConfigJSONTuple<{
  threshold: {
    message: string;
    aboveAmount: number;
    underAmount: number;
  }[];
}> = [
  'toast_free_delivery_thresholds',
  {
    threshold: [],
  },
];
